import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HsgOidcManagerService, HsgProfileService, HsgUserProfile, HsgUserService } from '@hhsg/hsg-asc';

import { Constants } from '../../shared/utilities/constants.util';
import { PermissionsService } from '../../shared/services/permissions.service';
import { RouteUtil } from '../../shared/utilities/route.util';
import { User } from '../../shared/models/user.model';
import { UserService } from '../../shared/services/user.service';
import { from, Observable, of, Subscription } from 'rxjs';
import { catchError, concatMap, map, switchMap, take, tap } from 'rxjs/operators';

@Component({
    selector: 'smt-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
    constructor(
        private router: Router,
        private oidcManager: HsgOidcManagerService,
        private hsgUserService: HsgUserService,
        private profileService: HsgProfileService,
        private userService: UserService,
        private permissionsService: PermissionsService) { 
    }

    loginText: string = "Logging in...";
    userData: HsgUserProfile;
    private subscription: Subscription;

    ngOnInit() {
        this.oidcManager
            .login()
            .pipe(
                take(1),
                map(isAuthorized => this.onLoginComplete(isAuthorized)),
                concatMap(() => this.oidcManager.getUserProfile()),
                map(async (userData: HsgUserProfile) => {
                    this.userData = userData;
                    this.hsgUserService.setUserProfile(userData);
                    const profileData = await this.profileService.getUserProfileData();
                    this.hsgUserService.setUserProfile({
                        ...userData,
                        ...profileData
                    } as HsgUserProfile);
                })
            )
            .subscribe(() => {
                this.announceUserProfile(this.userData).then(() => {
                    this.navigateOnSuccessfulLogin();
                });
            }, error => {
                console.error('Failed to authenticate with Identity Server. Error: ' + error);
                this.oidcManager.logoff();
            });
    }
    
    async announceUserProfile(userData: HsgUserProfile): Promise<HsgUserProfile> {
        this.loginText = "Loading user permissions...";

        let userProfile = await this.userService.getUserPermissions();

        if (userProfile) {
            this.permissionsService.announceUserPermissions(userProfile);

            this.loginText = `Logged in! Welcome, ${userData.firstName}!`;
        }    
        
        return userData;
    }
    

    onLoginComplete(isAuthorized : boolean): boolean {
        if (isAuthorized) {
            this.loginText = "Logged in! Redirecting...";
            return true;
        } 
        else {
            this.loginText = "Login Failed. Logging off...";
            this.oidcManager.logoff();
            return false;
        }
    }

    navigateOnSuccessfulLogin() {
        let page = '';
        let landingPage = sessionStorage.getItem(Constants.LandingPage);
        let userPermissions = this.permissionsService.getUserPermissions();

        if (landingPage && RouteUtil.checkPage(userPermissions, landingPage)) {
            page = landingPage;
        }

        let route = RouteUtil.findPageRoute(userPermissions, page);	

		if (route == "") {
			route = "/unauthorized";
        }
        
        this.router.navigate([route]);
    }
}
